import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { UserRound } from "lucide-react";
import { PageHeader } from "../ui";
import { lmsProfileApi } from "../Students/profile/profileApi";
import ProfileWorkspace from "./ProfileWorkspace";

/**
 * MyProfilePage — `/s/profile`, the signed-in student's door to their profile.
 * The same workspace answers the emailed no-login link at `/profile-form`.
 */
const MyProfilePage = () => {
  const [searchParams] = useSearchParams();
  const api = useMemo(() => lmsProfileApi(), []);
  return (
    <ProfileWorkspace
      api={api}
      focusAgreement={searchParams.get("tab") === "agreement"}
      header={() => <PageHeader icon={UserRound} title="My Profile" description="Your education, experience and documents." />}
    />
  );
};

export default MyProfilePage;
